//
// # SingleInstanceSelector
//
// Dropdown for selecting a single instance in a constraint.
// Used by differential and cross-coupled constraint types.
//

import React from "react";

export interface SingleInstanceSelectorProps {
  readonly label: string;
  readonly value: string | undefined;
  readonly onChange: (v: string) => void;
  readonly options: string[];
  readonly formatInstance: (name: string) => string;
  readonly inputClass: string;
  readonly inputStyle: React.CSSProperties;
  readonly labelClass: string;
  readonly labelStyle: React.CSSProperties;
}

export function SingleInstanceSelector({
  label,
  value,
  onChange,
  options,
  formatInstance,
  inputClass,
  inputStyle,
  labelClass,
  labelStyle,
}: SingleInstanceSelectorProps) {
  return (
    <div>
      <label className={labelClass} style={labelStyle}>
        {label}
      </label>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className={inputClass}
        style={inputStyle}
      >
        <option value="">— Select instance —</option>
        {options.map((name: string) => (
          <option key={name} value={name}>
            {formatInstance(name)}
          </option>
        ))}
      </select>
    </div>
  );
}
